import {Alert, AlertTitle, SnackbarOrigin} from '@mui/material';
import {Snackbar} from 'presentation/components';
import React from 'react';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {CustomSnackbarProps} from './types';

export const CustomSnackbar = ({
	title,
	description,
	snackProps,
	alertProps,
	dataTagId,
}: CustomSnackbarProps) => {
	const {isMobile} = useMediaQueries();
	const snackPosition: SnackbarOrigin = isMobile
		? {vertical: 'top', horizontal: 'center'}
		: {vertical: 'top', horizontal: 'right'};

	return (
		<Snackbar anchorOrigin={snackPosition} {...snackProps} data-tag-id={dataTagId}>
			<Alert sx={{maxWidth: 320, textAlign: 'left'}} {...alertProps}>
				<AlertTitle>{title}</AlertTitle>
				{description}
			</Alert>
		</Snackbar>
	);
};
